export const SocialMediaList = [
  {
    id: 'facebook',
    logo: `${process.env.PUBLIC_URL}/images/footer/social_medias/footer_facebook.svg`,
    url: 'https://www.facebook.com/SwissMedicalGroup/',
    alt: 'Facebook,',
  },
  {
    id: 'instagram',
    logo: `${process.env.PUBLIC_URL}/images/footer/social_medias/footer_instagram.svg`,
    url: 'https://www.instagram.com/swissmedicalgroup/',
    alt: 'Instagram',
  },
  {
    id: 'linkedin',
    logo: `${process.env.PUBLIC_URL}/images/footer/social_medias/footer_linkedin.svg`,
    url: 'https://www.linkedin.com/company/swissmedicalgroup/',
    alt: 'Linkedin',
  },
  {
    id: 'youtube',
    logo: `${process.env.PUBLIC_URL}/images/footer/social_medias/footer_youtube.svg`,
    url: 'https://www.youtube.com/@swissmedicalargentina',
    alt: 'YouTube',
  },
];
